export default __webpack_public_path__ + "static/media/addNewCaptionToEndOfLastOne.abf13990.jpg";